<template>
  <nav :class="{ inner }">
    <ul class="nav-list">
      <slot />
    </ul>
  </nav>
</template>

<script lang="ts" setup>
interface Props {
  inner?: boolean;
}

defineProps<Props>();
</script>

<style lang="scss" scoped>
nav {
  @apply w-full;

  &.inner {
    background: rgba(var(--color-selected-rgb), 0.5);
  }
}

.nav-list {
  @apply flex flex-col;
}

.inner :deep(.nav-item .link.active) {
  @apply relative;

  &::before {
    content: "";
    @apply absolute left-0 top-1/2 h-10 -translate-y-1/2;
    @apply bg-white;

    width: 3px;
  }

  &:not(:hover) {
    background-color: initial;
  }
}
</style>
